// src/components/NotFound.js
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className=" flex justify-center items-center w-full h-full ">
      <div className="  p-9 rounded-[32px] flex flex-col gap-3 max-w-[800px] max-h-[800px]">
        <img
          src="/images/not-found-image.svg"
          alt=""
          className="max-w-full max-h-full"
        />

        <p className="text-[20px] font-bold">
          {" "}
          صفحه مورد نظر در دسترس نمی‌باشد!{" "}
        </p>
        <p>
          متاسفانه صفحه مورد نظر شما پیدا نشد، برای پیدا کردن مسیر درست،
          میتوانید سری به داشبورد ونداولت بزنید
        </p>
        <Link
          to={"/home"}
          className="bg-dark text-white  rounded-md w-fit p-2 mx-auto"
        >
          {" "}
          صفحه اصلی
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
